import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Card, Grid } from "@material-ui/core";

import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { DialogAccessLogsScreen } from "./DialogAccessLogsScreen";
import { sortableField, columnNumberField } from "utils/tables-utils";

const columnModel = [
  sortableField({
    dataField: "Tela",
    text: "Nome da Tela",
    headerAlign: "center",
    align: "left",
  }),
  sortableField({
    dataField: "Sistema",
    text: "Sistema",
    headerAlign: "center",
    align: "center",
  }),
  columnNumberField(
    {
      dataField: "QuantidadeAcesso",
      text: "Quantidade de acessos",
    },
    true
  ),
];

const useStyles = makeStyles(componentStyles);

export default function TableAccessLogs({ dataTable }) {
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleGetScreenDetail = (data) => {
    setSelectedRow(data);
    setOpenDialog(true);
  };

  return (
    <Grid item xs={12}>
      <Card classes={{ root: classes.cardRoot }} style={{ display: "flex" }}>
        <ToolkitTable
          searched={Boolean(dataTable)}
          keyField="Id"
          dataTable={dataTable}
          columnModel={columnModel}
          headerTitle="Telas"
          onRowClick={(_, row) => handleGetScreenDetail(row)}
          pagination={{
            options: [25, 50, 100],
            defaultOption: 25,
          }}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado."
          csvFileName="TelasLogsDeAcesso"
        />
      </Card>
      {openDialog && (
        <DialogAccessLogsScreen
          open={openDialog}
          data={selectedRow}
          handleClose={() => {
            setOpenDialog(false);
          }}
        />
      )}
    </Grid>
  );
}
